export const blockIconsActivitiesConfirmationNumberNew = (
	<span className='material-symbols-outlined'>confirmation_number</span>
);
